import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles'
import Grid from 'material-ui/Grid'
import Avatar from 'material-ui/Avatar'
import Typography from 'material-ui/Typography/Typography'

import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import {
  capitalize
} from '../../utils/helpers'

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default, // toggle this to get two-tone background
  },
  sectionWrapper: {
    padding: 50,
  },
  itemCard: {
    [theme.breakpoints.up('md')]: {
      padding: '0px 20px 20px 20px'
    },
    [theme.breakpoints.only('sm')]: {
      padding: '20px 10px 10px 10px'
    },
    [theme.breakpoints.only('xs')]: {
      padding: '20px 0px 10px 0px'
    },
  },
  icon: {
    color: theme.palette.secondary.light,
  },
  iconAvatar: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.text.primary,
    height: "65px",
    width: "65px",
    margin: '25px auto',
  },
})

class ListSection extends Component {

  renderItemGrid = (sectionItems) => {

    const {
      classes
    } = this.props

    const items = sectionItems
    let renderedItems

    if (items.length === 1) {
      // xs = 12, 1 item full width
      renderedItems = items.map((item, index) => ( 
        <Grid
          key={index}
          item
          xs={12}
        >

          <Grid
            container
            spacing={0}
            className={classes.itemCard}
            justify="center"
          >

            <Grid
              item
              xs={12}
            >

              {item.icon &&
                <Avatar className={classes.iconAvatar}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    className={classes.icon}
                    // border
                    size="lg"
                  />
                </Avatar>}

            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="title"
                component="h3"
                align="center"
                gutterBottom
              >
                {item.title}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="subheading"
                component="p"
                align="center"
              >
                {item.description}
              </Typography>
            </Grid>

          </Grid>

        </Grid>
      ))

    } else if (items.length === 2) {
      // xs=12,sm=6
      renderedItems = items.map((item, index) => (
        <Grid
          key={index}
          item
          xs={12}
          md={6}
        >

          <Grid
            container
            spacing={0}
            className={classes.itemCard}
            justify="center"
          >

            <Grid
              item
              xs={12}
            >

              {item.icon &&
                <Avatar className={classes.iconAvatar}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    className={classes.icon}
                    // border
                    size="lg"
                  />
                </Avatar>}

            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="title"
                component="h3"
                align="center"
                gutterBottom
              >
                {item.title}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="subheading"
                component="p"
                align="center"
              >
                {item.description}
              </Typography>
            </Grid>

          </Grid>

        </Grid>
      ))

    } else if (items.length === 3) {
      // xs=12,md=4
      renderedItems = items.map((item, index) => (
        <Grid
          key={index}
          item
          xs={12}
          md={4}
        >

          <Grid
            container
            spacing={0}
            className={classes.itemCard}
            justify="center"
          >

            <Grid
              item
              xs={12}
            >

              {item.icon &&
                <Avatar className={classes.iconAvatar}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    className={classes.icon}
                    // border
                    size="lg"
                  />
                </Avatar>}

            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="title"
                component="h3"
                align="center"
                gutterBottom
              >
                {item.title}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="subheading"
                component="p"
                align="center"
              >
                {item.description}
              </Typography>
            </Grid>

          </Grid>

        </Grid>
      ))

    } else if (items.length === 4) {
      //xs=12,sm=6,md=3
      renderedItems = items.map((item, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sm={6}
          lg={3}
        >

          <Grid
            container
            spacing={0}
            className={classes.itemCard}
            justify="center"
          >

            <Grid
              item
              xs={12}
            >

              {item.icon &&
                <Avatar className={classes.iconAvatar}>
                  <FontAwesomeIcon
                    icon={item.icon}
                    className={classes.icon}
                    // border
                    size="lg"
                  />
                </Avatar>}

            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="title"
                component="h3"
                align="center"
                gutterBottom
              >
                {item.title}
              </Typography>
            </Grid>

            <Grid
              item
              xs={12}
            >
              <Typography
                variant="subheading"
                component="p"
                align="center"
              >
                {item.description}
              </Typography>
            </Grid>

          </Grid>

        </Grid>
      ))

    }

    return renderedItems
  }

  render() {

    const {
      classes,
      isFullScreen,
      title,
      subTitle,
      listItems
    } = this.props

    return (
      <Grid
        item
        xs={isFullScreen ? 12 : 10}
        className={classes.root}
      >

        <Grid container spacing={0} className={classes.sectionWrapper}>

          {/* Title and Sub Title */}
          <Grid item xs={12}>

            {title && typeof title === 'string' &&
              <Typography
                variant="display1"
                component="h2"
                align="center"
                gutterBottom
              >
                {title}
              </Typography>
            }
            {title && typeof title === 'function' &&
              <Typography
                variant="display1"
                component="h2"
                align="center"
                gutterBottom
              >
                {title()}
              </Typography>
            }
            {title && typeof title === 'object' &&
              <Typography
                variant="display1"
                component="h2"
                align="center"
                gutterBottom
              >
                {title}
              </Typography>
            }

            {subTitle && typeof subTitle === 'string' &&
              <Typography
                variant="headline"
                component="h3"
                align="center"
                gutterBottom
              >
                {subTitle}
              </Typography>
            }
            {subTitle && typeof subTitle === 'function' &&
              <Typography
                variant="headline"
                component="h3"
                align="center"
                gutterBottom
              >
                {subTitle()}
              </Typography>
            }
            {subTitle && typeof subTitle === 'object' &&
              <Typography
                variant="headline"
                component="h3"
                align="center"
                gutterBottom
              >
                {subTitle}
              </Typography>
            }

          </Grid>

          {/* Each List Item */}
          {this.renderItemGrid(listItems)}

        </Grid>

      </Grid>
    );
  }
}

ListSection.propTypes = {
  classes: PropTypes.object.isRequired,
  isFullScreen: PropTypes.bool.isRequired,
  listItems: PropTypes.array.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  subTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),  
}

export default withStyles(styles)(ListSection)


// WEBPACK FOOTER //
// ./src/components/sections/ListSection.js